// internal voucher definitions
import { Type } from '@sinclair/typebox';
import { NullishType } from './standard-schema.js';
const voucherReferenceTypeArray = [
    'INVOICE',
    'SUPPLIERINVOICE',
    'INVOICEPAYMENT',
    'SUPPLIERPAYMENT',
    'MANUAL',
    'CASHINVOICE',
    'ACCRUAL',
];
export const VoucherReferenceTypeSchema = Type.Union(voucherReferenceTypeArray.map((type) => Type.Literal(type)));
// The only reference types Vera writes. `satisfies` constrains these to the wider
// inbound vocabulary Fortnox may send, above.
export const VoucherRole = {
    SupplierDebt: 'INVOICE', // voucher series D
    SupplierPayment: 'INVOICEPAYMENT', // voucher series E
};
export const GetSupplierInvoiceVoucherSchema = Type.Object({
    id: Type.String(),
    supplierInvoiceId: Type.String(),
    voucherNumber: Type.Number(),
    voucherSeries: Type.String(),
    fortnoxFileConnectionId: Type.String(),
    year: Type.Union([Type.Number(), Type.Null()]),
    transactionDate: Type.Union([Type.String(), Type.Null()]),
    referenceType: Type.Union([Type.Enum(VoucherRole), Type.Null()]),
    createdAt: Type.Date(),
});
export const VoucherRowSchema = Type.Object({
    Account: Type.Number(),
    CostCenter: NullishType(Type.String()),
    Credit: NullishType(Type.Number()),
    Debit: NullishType(Type.Number()),
    Description: NullishType(Type.String()),
    Project: NullishType(Type.String()),
    Quantity: NullishType(Type.Number()),
    Removed: NullishType(Type.Boolean()),
    TransactionInformation: NullishType(Type.String()),
});
export const VoucherRowsSchema = Type.Array(VoucherRowSchema);
export const FortnoxVoucherSchema = Type.Object({
    '@url': NullishType(Type.String()),
    ApprovalState: NullishType(Type.Number()),
    Comments: NullishType(Type.String()),
    CostCenter: NullishType(Type.String()),
    Description: Type.String(),
    Project: NullishType(Type.String()),
    ReferenceNumber: NullishType(Type.String()),
    ReferenceType: NullishType(VoucherReferenceTypeSchema),
    TransactionDate: Type.String(), // "YYYY-MM-DD"
    VoucherNumber: NullishType(Type.Number()),
    VoucherRows: VoucherRowsSchema,
    VoucherSeries: Type.String(),
    Year: Type.Number(), // "YYYY"
});
